import { Component, ElementRef } from '@angular/core';

import { AttributeDataService } from '../../services/attribute-data.service';
import { ComponentsService } from '../../services/components.service';
import { FA4_ICONS } from './icon-fa4.icons';

@Component({
  selector: 'template-component-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false,
})
export class IconComponent {
  public componentId: string;
  public name: string;
  public color: string;
  public filterText: string = '';

  private readonly allIcons: readonly string[] = FA4_ICONS;

  constructor(
    private elementRef: ElementRef,
    private componentsFactory: ComponentsService,
    private attributeDataFactory: AttributeDataService,
  ) {
    this.componentsFactory.registerDirective({
      type: 'rise-icon',
      element: this.elementRef.nativeElement,
      show: () => {
        this.componentId = this.componentsFactory.selected.id;
        this._load();
        this.scrollSelectedIntoView();
      },
    });
  }

  get filteredIcons(): readonly string[] {
    const query = this.filterText.trim().toLowerCase();
    if (!query) {
      return this.allIcons;
    }
    return this.allIcons.filter((icon) => icon.includes(query));
  }

  selectIcon(icon: string): void {
    this.name = icon;
    this.attributeDataFactory.setAttributeData(this.componentId, 'name', icon);
  }

  onColorChange(): void {
    this.attributeDataFactory.setAttributeData(
      this.componentId,
      'color',
      this.color || null,
    );
  }

  private scrollSelectedIntoView(): void {
    setTimeout(() => {
      const selected: HTMLElement | null =
        this.elementRef.nativeElement.querySelector('.icon-option--selected');
      selected?.scrollIntoView({ block: 'center' });
    });
  }

  private _load(): void {
    this.name = this.attributeDataFactory.getAvailableAttributeData(
      this.componentId,
      'name',
    );
    this.color = this.attributeDataFactory.getAvailableAttributeData(
      this.componentId,
      'color',
    );

    this.filterText = '';
  }
}
